
<section class="pt-5">

  <mat-grid-list cols="2" rowHeight="800px">
    <mat-grid-tile>
      <div>
       <!--
         If you want to add instructions on the platform, please do so using this section
         <h2>Here are some general notes for you</h2> 
       <p>soemthing</p>
       -->
      <img
        src="../../../assets/imgs/oboard.png"
        alt="login form"
        class="img-fluid" style="border-radius: 1rem 0 0 1rem;"
      />
      </div>
   

    </mat-grid-tile>
    <mat-grid-tile>
          <form [formGroup]="onBoardingForm" >
         <h2>Onboarding</h2>
          <h4>What should we call you?</h4>
        
          <mat-form-field>
            <mat-label>Display Name</mat-label>
            <input matInput 
            type="text" 
            formControlName = "displayName" 
            style="width: 100%;"
            [ngClass]="{ 'is-invalid': submitted && f['displayName'].errors }"
            />  
            <div *ngIf="submitted && f['displayName'].errors" class="invalid-feedback">
                <div *ngIf="f['displayName'].errors['required']">Display Name Required</div>
            </div>
            </mat-form-field>
          
            <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput 
            type="text" 
            formControlName = "firstName" 
          
            [ngClass]="{ 'is-invalid': submitted && f['firstName'].errors }"
            />  
            <div *ngIf="submitted && f['firstName'].errors" class="invalid-feedback">
                <div *ngIf="f['firstName'].errors['required']">Please enter your first name</div>
            </div>
            </mat-form-field>
          <mat-form-field >
            <label>Last Name</label>
            <input matInput 
            type="text" 
            formControlName = "lastName" 
          
            [ngClass]="{ 'is-invalid': submitted && f['lastName'].errors }"
            />  
            <div *ngIf="submitted && f['lastName'].errors" class="invalid-feedback">
                <div *ngIf="f['lastName'].errors['required']">Please enter your last name</div>
            </div>
          </mat-form-field>
          <h4>Your Company or Organization Name:</h4>
          <mat-form-field >
            <label>Company Name</label>
            <input matInput 
            type="text" 
            formControlName = "companyName" 
          
            [ngClass]="{ 'is-invalid': submitted && f['companyName'].errors }"
            />  
            <div *ngIf="submitted && f['companyName'].errors" class="invalid-feedback">
                <div *ngIf="f['companyName'].errors['required']">Please enter your company name</div>
            </div>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Type of User</mat-label>
            <mat-select   formControlName ="typeOfUser" required>
              <mat-option>--</mat-option>
              <mat-option *ngFor="let typeUser of typeOfUsers" [value]="typeUser.type">
                {{typeUser.value}}
              </mat-option>
            </mat-select>
            <div *ngIf="submitted && f['typeOfUser'].errors" class="invalid-feedback">
              <div *ngIf="f['typeOfUser'].errors['required']">Please choose the type of user</div>
          </div>
          </mat-form-field>

          <mat-form-field >
            <label>Reffered By</label>
            <input matInput 
            type="text" 
            formControlName = "refferedBy" 
          
            [ngClass]="{ 'is-invalid': submitted && f['refferedBy'].errors }"
            />  
          </mat-form-field>

          <div class="form-group form-check my-auto">
            <mat-checkbox 
            formControlName="acceptTerms" 
            class="form-check-input" 
            [ngClass]="{ 'is-invalid': submitted && f['acceptTerms'].errors }">
              
          </mat-checkbox>
              
          
              <mat-label for="acceptTerms" 
            class="form-check-label">
            I have read and agree to the 
                <a href="http://sustainible.io/terms-conditions/" target="_blank">Terms and Conditions</a> and <a href="http://sustainible.io/privacy-policy/" target="_blank">Privacy Policy</a>.</mat-label>

                <div *ngIf="submitted && f['acceptTerms'].errors" class="invalid-feedback">
                  Accepting Terms and Conditions and Privacy Policy is required to onboard.
                </div>
          </div>
        
          <div class="pt-3" >
            <button mat-raised-button color="primary" type="submit" (click)="onSubmit()">Submit</button>
          </div>

        </form>
     
    
    </mat-grid-tile>
  </mat-grid-list>
</section>

